enum ErrorMessages {
    // Fetch Errors
    FetchModelOverviewError = 'Fetch Model Overview Error'
}

export default ErrorMessages;